<div class="breadcrumb">
  <div class="title">
    Dashboard
  </div>
  <div class="path-wrapper">
    <span class="page">
      Project Listing
    </span>
    <mat-icon>chevron_right</mat-icon>
    <span class="page active">
      Project Listing
    </span>
  </div>
</div>